import { format } from "date-fns";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "../../../../components/ui/alert";
import { Card, CardContent } from "../../../../components/ui/card";
import { SpinnerSkeleton } from "../../../../components/ui/skeleton-loaders";
import { AntecipationStatsSection } from "./components/antecipacao-stats-section";
import { AntecipationTable } from "./components/antecipacao-table";
import { DateFilterSection } from "./components/date-filter-section";
import { useAntecipation } from "./hooks/use-antecipacao";

export default function AntecipationVisualization() {
  const {
    selectedDate,
    filterDate,
    stats,
    records,
    hasData,
    isLoading,
    error,
    handleDateChange,
  } = useAntecipation();

  return (
    <div className="p-6 space-y-6">
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground">
          Visualização de Antecipação - Gestor
        </h1>
        <p className="text-muted-foreground">
          Visualize as solicitações de antecipação realizadas.
        </p>
      </div>

      <DateFilterSection
        selectedDate={selectedDate}
        onDateChange={handleDateChange}
      />

      {error && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Ocorreu um erro ao carregar os dados de antecipação. Por favor,
            tente novamente mais tarde.
          </AlertDescription>
        </Alert>
      )}

      {isLoading && <SpinnerSkeleton />}

      {!isLoading && !error && stats && (
        <AntecipationStatsSection
          stats={stats}
          selectedDate={format(selectedDate, "dd/MM/yyyy")}
        />
      )}

      {!isLoading && !error && hasData && (
        <AntecipationTable
          data={records}
          isLoading={isLoading}
          exportFileName={`antecipation-requests-${filterDate}`}
        />
      )}

      {!isLoading && !error && !hasData && (
        <Card>
          <CardContent className="py-12">
            <div className="text-center">
              <p className="text-muted-foreground">
                Não há solicitações de antecipação para a data selecionada.
              </p>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
